import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/panel/nancy/orders/")({
  head: () => ({ meta: [{ title: "Orders | Nancy | People AI" }] }),
  component: lazyRouteComponent(
    () => import("@/routes/panel/-components/panel-history"),
    "PanelHistory",
  ),
});
